var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcVideo = function SvgIcVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.166 5.833 13.333 10l5.833 4.167V5.833ZM11.666 4.167H2.5c-.92 0-1.667.746-1.667 1.666v8.334c0 .92.746 1.666 1.667 1.666h9.166c.92 0 1.667-.746 1.667-1.666V5.833c0-.92-.746-1.666-1.667-1.666Z"
  })));
};
export default SvgIcVideo;